<div class="dashboard-container d-flex flex-column basis-100 gap-32">
  <div class="description-container d-flex flex-row basis-100">
    <h1 class="description-title">
      <small>{{ 'DASHBOARD.WELCOME' | translate }},&nbsp;</small>
      <em>{{ getUserInfo?.preferred_username }}</em>
    </h1>
  </div>

  <div class="d-flex flex-row basis-100 gap-32 justify-start xs-flex-column">
    <div
      *ngIf="
        AvailableModules.length > 0 &&
        this.currentUserRole === UserRole.CarrierAdmin
      "
      class="material-shadow portal-font-color d-flex flex-column basis-30 card-container card-margin lg-basis-30 md-basis-35 sm-basis-45 xs-basis-100"
    >
      <div class="card-container basis-100">
        <h2 class="card-title">
          {{ 'DASHBOARD.CERTIFICATES.TITLE' | translate }}
        </h2>
      </div>
      <div class="separator"></div>
      <div
        style="position: relative"
        class="card-container basis-100 d-flex flex-column"
      >
        <h2>{{ 'DASHBOARD.CERTIFICATES.SUBTITLE' | translate }}</h2>
        <ul class="links-list">
          <li *ngFor="let certificate of carrierCertificates">
            {{ 'DASHBOARD.CERTIFICATES.CERTIFICATE' | translate }}
            <a
              [routerLink]="['/secure/carriers/my-profile']"
              [queryParams]="{ certificateId: certificate.id }"
            >
              {{ certificate.Id }} {{ certificate.documentTypeName }}</a
            >
          </li>
        </ul>
        <ngx-spinner
          bdColor="white"
          color="#b3b6ba"
          type="ball-scale-multiple"
          [fullScreen]="false"
        >
          <b class="primary-color">{{ 'TIMESLOT.LOADING' | translate }}</b>
        </ngx-spinner>
      </div>
    </div>
    <div
      *ngIf="userHasAccessOrders"
      class="material-shadow portal-font-color d-flex flex-column basis-30 card-container card-margin lg-basis-30 md-basis-35 sm-basis-45 xs-basis-100"
    >
      <div class="card-container basis-100">
        <h2 class="card-title">{{ 'DASHBOARD.ORDER' | translate }}</h2>
      </div>
      <div class="separator"></div>
      <div
        style="position: relative"
        class="card-container basis-100 d-flex flex-column"
      >
        <h2>{{ 'DASHBOARD.ORDERS-CARD.DELIVERY-ACTUALS' | translate }}</h2>
        <ul class="links-list">
          <li *ngFor="let order of orders">
            {{ 'DASHBOARD.ORDERS-CARD.ORDER-NR' | translate }}
            <a [routerLink]="[this.ordersBaseUrl + order.id]">
              {{ order.id }}</a
            >
          </li>
        </ul>
        <ngx-spinner
          bdColor="white"
          color="#b3b6ba"
          type="ball-scale-multiple"
          [fullScreen]="false"
        >
          <b class="primary-color">{{ 'TIMESLOT.LOADING' | translate }}</b>
        </ngx-spinner>
      </div>
    </div>
  </div>
</div>

<ng-template #snackBarTemplate>
  <span>
    <em
      class="fas fa-lg fa-exclamation-circle information-icon ng-star-inserted"
    >
    </em>
    <span class="mx-2 portal-font-family message">
      {{ warningMessage }}
    </span>
  </span>
</ng-template>
